/**
 * Question types for backend API
 * This enum contains only the types that the backend supports
 * DESCRIBE_IMAGE_ONLY_PRONUNCIATION is mapped to DESCRIBE_IMAGE for backend compatibility
 */
export enum BackendQuestionType {
  MISSING_LETTERS = 'MISSING_LETTERS',
  MISSING_WORD = 'MISSING_WORD',
  CHOICES = 'CHOICES',
  BUILD_SENTENCE = 'BUILD_SENTENCE',
  READ_SENTENCE = 'READ_SENTENCE',
  COMPREHENSION = 'COMPREHENSION',
  TRANSCRIBE_AND_SCORE = 'TRANSCRIBE_AND_SCORE',
  DESCRIBE_IMAGE = 'DESCRIBE_IMAGE', // This is what backend accepts (not DESCRIBE_IMAGE_ONLY_PRONUNCIATION)
  FREE_TEXT_ONLY_PRONUNCIATION = 'FREE_TEXT_ONLY_PRONUNCIATION',
}
